import { type HttpInterceptorFn } from '@angular/common/http';

import { AMP_API_BASE_URL } from '../constants/amp-api-base-url';

const hasApiBaseUrl = (url: string) =>
  url === AMP_API_BASE_URL || url.startsWith(`${AMP_API_BASE_URL}/`);

export const ampApiBaseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const url = request.url;

  if (url.startsWith('/') && !hasApiBaseUrl(url)) {
    return next(request.clone({ url: `${AMP_API_BASE_URL}${url}` }));
  }

  return next(request);
};
